import { makeStyles } from '@material-ui/core';

export const hotNoteCellStyles = makeStyles(theme => ({
    cell: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
        width: '100%',
        minHeight: 24,
    },
    empty: {
        color: theme.palette.text.disabled,
    },
    icon: {
        color: theme.palette.action.active,
        marginLeft: 'auto'
    },
    readOnlyContent: {
        fontSize: 14,
        '& p': { margin: 0 },
    },
}));
